import { create } from "zustand";

export type ProvablyFairState = {
  nextClientSeed: string;
  nextServerHash: string;
  setNextClientSeed: (seed: string) => void;
  setNextServerHash: (hash: string) => void;
  reset: () => void;
};

export const useProvablyFairStore = create<ProvablyFairState>((set) => ({
  nextClientSeed: "",
  nextServerHash: "",
  setNextClientSeed: (seed) => set(() => ({ nextClientSeed: seed })),
  setNextServerHash: (hash) => set(() => ({ nextServerHash: hash })),
  reset: () => set(() => ({ nextClientSeed: "", nextServerHash: "" })),
}));
